module.exports = __webpack_public_path__ + "static/media/arrow.5a2fc18d.svg";